<footer class="sitemap-footer" aria-label="footer">
  <section class="text-container">
    <div class="group-title">{{ (customVariables$ | async)?.sitemap_footer_title }}</div>
    <div tabindex="0" class="footer-text">
      <span>{{ (customVariables$ | async)?.sitemap_footer_text }}</span>
      <div class="license-info" [innerHTML]="(customVariables$ | async)?.travel_license_info"></div>
    </div>
  </section>
  <section class="links-section">
    <div class="group">
      <div class="group-title">Centurion Service</div>
      <ng-container *ngFor="let link of mainNavLinks$ | async">
        <span *ngIf="link.isVisible">
          <a href [attr.aria-label]="link.ariaLabel" [routerLink]="link.routerLink">{{
            link.customName ? link.customName : (link.translate | translate)
          }}</a>
        </span>
      </ng-container>
    </div>
    <div class="group">
      <div class="group-title">{{ 'GlobalNav:NavBenefits' | translate }}</div>
      <div class="link-groups-container" *ngIf="siteMap$ | async as siteMap">
        <div class="link-group" *ngFor="let page of siteMap[0]?.subpages">
          <a href [fragment]="page.link | fragment" [routerLink]="page.link | fragment : false">{{ page.name }}</a>
          <a
            *ngFor="let subpage of page.subpages"
            href
            [fragment]="subpage.link | fragment"
            [routerLink]="subpage.link | fragment : false"
            >{{ subpage.name }}</a
          >
        </div>
        <div class="link-group">
          <a
            href="https://www.swisscard.ch/en/private-customers/services/centurion-card"
            target="_blank"
            rel="noopener noreferrer"
          >
            Help Center
            <mat-icon>launch</mat-icon>
          </a>
        </div>
      </div>
    </div>
  </section>
  <section class="general-links-section">
    <a href [translate]="'FooterComponent:FooterAccessibility'" [routerLink]="['product/accessibility']">
      Accessibility
    </a>
    <a href [translate]="'FooterComponent:FooterPrivacy'" [routerLink]="['product/privacy']">Privacy Statement</a>
    <a href [translate]="'FooterComponent:FooterTerms'" [routerLink]="['product/terms']">Terms & Conditions</a>
    <a href [translate]="'FooterComponent:FooterFaq'" [routerLink]="['product/faq']">FAQs</a>
    <a href [translate]="'FooterComponent:FooterContact'" [routerLink]="['product/contact']">Contact</a>
  </section>
</footer>
